// extracted by css-extract-rspack-plugin
export default {"container":"container-HLYI5E","main":"main-i6FZfW"};